import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type PageHeaderProps = {
  title: ReactNode;
  description?: ReactNode;
  /** Optional content rendered beside the title (e.g. a count badge). */
  badge?: ReactNode;
  actions?: ReactNode;
  className?: string;
};

/**
 * Standard page title row: title + optional subtitle on the left, actions on the
 * right. Matches the API keys page — actions are vertically centered against the
 * title/description block from the `md` breakpoint up.
 */
export const PageHeader = ({ title, description, badge, actions, className }: PageHeaderProps) => (
  <div className={cn("flex flex-col gap-4 md:flex-row md:items-center md:justify-between", className)}>
    <div>
      <div className="flex items-center gap-2">
        <h1 className="text-3xl font-bold">{title}</h1>
        {badge}
      </div>
      {description ? <p className="text-muted-foreground">{description}</p> : null}
    </div>
    {actions ? <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row">{actions}</div> : null}
  </div>
);
